import React, { Component } from 'react'
import styles from './List.css'
import { dateFormatter, rupiah } from 'utils/formatter'

class Row extends Component {

  render () {
    let {payment} = this.props
    return (
      <tr className={`${this.props.isSelected ? styles.selected : ''}`} onClick={this.onClickRow}>
        <td className={styles['date']}>{dateFormatter(payment.created_at)}</td>
        <td className={styles['outlet']}>{payment.outlet_name}</td>
        <td className={styles['sale']}>{this._purchaseHistoryTotalFormatter(payment)}</td>
      </tr>
    )
  }

  _purchaseHistoryTotalFormatter = (payment) => {
    let amount = payment.is_refunded
      ? rupiah(parseFloat(payment.refund_amount).toFixed(0))
      : rupiah(parseFloat(payment.total_collected).toFixed(0))

    if (payment.is_refunded) {
      amount = '(' + amount + ')'
    }

    return amount
  }

  onClickRow = () => {
    this.props.onClickRow(this.props.payment)
  }
}

export default Row



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/PurchaseHistory/List/Row.js